import React from 'react';
import PropTypes from 'prop-types';
import intlShape from '@/shared/utils/intlShape';
import AbsenceCorrectionModal from '../modals/AbsenceCorrectionModal';
import BatchInitCounterModal from '../modals/BatchInitCounterModal';

const HrmModals = ({ modal, data, onCloseModals, intl }) => {
  if (!modal) return null;

  switch (modal) {
    case 'counterDetails':
      return (
        <AbsenceCorrectionModal
          show
          onClose={onCloseModals}
          intl={intl}
          counter={data.counter}
          hoursInDay={data.hoursInDay}
        />
      );
    case 'initCounter':
      return (
        <BatchInitCounterModal
          show
          onClose={onCloseModals}
          intl={intl}
          year={data.year}
          resourceId={data.resourceId}
          inDays={data.inDays}
          onSave={data.save}
        />
      );
    default:
      return null;
  }
};

HrmModals.propTypes = {
  modal: PropTypes.string.isRequired,
  data: PropTypes.any,
  onCloseModals: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
};
HrmModals.defaultProps = {
  data: undefined,
};

export default HrmModals;
